import { databases, DB_ID, COLLECTIONS, ID } from "../appwrite";
import type { Models } from "appwrite";

export interface Service {
    $id?: string;
    slug: string;           // URL id, e.g. "hvac"
    title: string;
    shortTitle: string;
    desc: string;
    icon: string;           // lucide icon name, e.g. "Wind"
    img: string;
    color: string;          // tailwind classes
    colorAccent: string;    // hex colour
    features: string;       // JSON: string[]
    benefits: string;       // JSON: {title:string, desc:string}[]
    faqs: string;           // JSON: {q:string, a:string}[]
    sortOrder: string;      // "1", "2" ... for ordering
    status: string;         // "Active" | "Inactive"
}

const COL = COLLECTIONS.SERVICES ?? "services";

export const servicesService = {
    list: () =>
        databases
            .listDocuments(DB_ID, COL)
            .then((r) => r.documents as unknown as Array<Service & Models.Document>),

    create: (data: Omit<Service, "$id">) =>
        databases.createDocument(DB_ID, COL, ID.unique(), data),

    update: (id: string, data: Partial<Service>) => {
        const {
            $id,
            $createdAt,
            $updatedAt,
            $permissions,
            $databaseId,
            $collectionId,
            ...updateData
        } = data as any;
        return databases.updateDocument(DB_ID, COL, id, updateData);
    },

    remove: (id: string) =>
        databases.deleteDocument(DB_ID, COL, id),
};

// ── Helpers ──────────────────────────────────────────────────────────────────
export function parseFeatures(json: string): string[] {
    try { return JSON.parse(json); } catch { return []; }
}

export function parseBenefits(json: string): { title: string; desc: string }[] {
    try { return JSON.parse(json); } catch { return []; }
}

export function parseFaqs(json: string): { q: string; a: string }[] {
    try { return JSON.parse(json); } catch { return []; }
}
